// extracted by mini-css-extract-plugin
export default {"cls1":"Ak2LzgESY3es01fS1C8E","cls2":"b5DUopirRGtCo7WwEuHi Ak2LzgESY3es01fS1C8E","isNotInlineEmbed":"ay7wYeeCFojVf1x8uLy4","isNotEmbedded":"GFGgdp3qKF5bNtT2W4G8"};